import React, { useEffect, useState } from 'react'
import { css } from 'aphrodite';
import { Userpilot } from 'userpilot';
import { Paper } from '@mui/material';
import { convertPxToRem, MESSAGE_TYPE, messageManager, translate } from '../../helper';
import TextBase from '../../common/text';
import { ActiveSubscription } from '../../common/active-subscription';
import { SuccessModal } from '../../common/success-subscription';
import PaymentMethodInfo from '../../common/payment-method-info';
import { SubscriptionHeader } from '../../common/subscription-header';
import AllPaymentMethods  from '../../common/payments';
import ButtonGradient from '../../common/button-gradient';
import { Colors } from '../../themes/Colors';
import { SVGImageComponentReact } from '../../themes/Images';
import { useCreateVendorSubscription, useUpdateVendorSubscription } from '../../hooks/useSubscriptions';
import { styles } from './styles';
import { useScreenSubscription } from '../subscription/screenProviderLocationAccount';
import { useGetPaymentMethods } from '../../hooks/usePayment';
import { usePaymentPolling } from '../../hooks/usePaymentPolling';
import { ACHBankAccountModal } from '../../common/ach/ACHBankAccountModal';
import { WORK_FLOW_COMMON_SCREENS } from '../subscription/const';
import { ROUTER_NAME } from '../../router/routers';
import { useNavigate } from 'react-router-dom';
import { AddPaymentMethodModal }from '../../common/payments/AddPaymentMethodModal';
import { resolveCssVarValue } from '../../utils/CommonFunction';
import CustomSpinner from '../../common/CustomSpinner';

const initialSuccessSubscription = {
  showModal: false,
  data: {},
  isUpdate: false
}

export const PaymentInfo = () => {
  const { 
    selectedSubscription, 
    childAccount, 
    triggerRefresh, 
    goBack,
    navigateTo,
  } = useScreenSubscription();
  const { paymentMethods, isLoading, refetchPaymentMethods } = useGetPaymentMethods();
  const childAccountData  = childAccount;

  const [successSubscription, setSuccessSubscription] = 
    useState(initialSuccessSubscription)
  const [showAchModal, setShowAchModal] = useState(false);
  const [waitingForDefault, setWaitingForDefault] = useState(false);
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  const [waitingForBankId, setWaitingForBankId] = useState(null);
  usePaymentPolling({ refetch: refetchPaymentMethods, enabled: waitingForDefault });

  const navigate = useNavigate();

    useEffect(() => {
      if (!waitingForBankId) return;
      if (waitingForDefault) {
        const found = (paymentMethods || []).find(
            pm => pm.is_default && (pm.id === waitingForBankId || pm.fingerprint === waitingForBankId || pm.last4 === waitingForBankId)
          );
        if (found) {
          setWaitingForDefault(false);
          setWaitingForBankId(null);
        }
      }
    }, [paymentMethods, waitingForDefault, waitingForBankId]);


  const onErrorSubscription = (data) => {
    messageManager({
      type: MESSAGE_TYPE.error,
      messageShow: data?.error
    });
  }

  const onSuccessSubscription = (data) => {
    if(!data?.detail) return;
    const isUpgrade = !!selectedSubscription?.isUpgrade;
    Userpilot.track(isUpgrade ? 'Subscription upgraded' : 'Subscription active');
    messageManager({
      type: MESSAGE_TYPE.success,
      messageShow: isUpgrade ? (translate('subscriptionUpdated') || 'Subscription updated successfully') : (translate('subscriptionCreated') || 'Subscription created successfully')
    });
    setSuccessSubscription({
      showModal: true,
      isUpdate: isUpgrade,
      data: {
        name: translate(selectedSubscription?.title),
        amount: selectedSubscription?.price,
        interval: selectedSubscription?.recurringInterval === 1 ? 'monthSort' : 'year',
      }
    })
  }

  const handleCloseSubscription = () => {
    setSuccessSubscription(initialSuccessSubscription)
    triggerRefresh()
    navigate(ROUTER_NAME.subscription, { state: {initialTab: childAccountData ? 'location' : 'master'} })
  }

  const { createVendorSubscription, isCreatingSubscription } = useCreateVendorSubscription(onSuccessSubscription, onErrorSubscription);
  const { updateVendorSubscription, isUpdatingVendorSubscription } = useUpdateVendorSubscription(onSuccessSubscription, onErrorSubscription);

  const handlePay = () => {
  const defaultAch = (paymentMethods || []).find(pm => pm?.is_default);
    if (!defaultAch) {
      messageManager({ type: MESSAGE_TYPE.error, messageShow: translate('pleaseAddPaymentMethod') || 'Please add payment method' });
      setShowAddPaymentModal(true)
      return;
    }
    if (!selectedSubscription) {
      messageManager({ type: MESSAGE_TYPE.error, messageShow: translate('noSubscriptionSelected') || 'No subscription selected' });
      return;
    }
    const payloadBase = {
      subscription_id: selectedSubscription?.paymentId,
      ...(childAccountData?.id ? { child_account_id: childAccountData.id } : {})
    };
    if (selectedSubscription?.isUpgrade) {
      updateVendorSubscription(payloadBase);
    } else {
      createVendorSubscription(payloadBase);
    }
  };

  const goAddCard = () => {
    navigateTo(WORK_FLOW_COMMON_SCREENS.ADD_PAYMENT_METHOD)
  }
  return (
    <>
      <div className={css(styles.backButtonContainer)} onClick={goBack}>
        <SVGImageComponentReact.IconArrowBack style={{width:"var(--fs-lg)", height:"var(--fs-lg)"}}/>
      </div>
     
      <Paper className={css(styles.paymentContainer)}>
        <div style={{ display: 'flex' , marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
          
          <TextBase fontWeight={400} size={'calc(var(--fs-xs)*1.698113)'} color={Colors.titlePage}>
            type
          </TextBase>
          
          <TextBase
            style={{ marginLeft: 'var(--sp-sm)' }}
            fontWeight={600}
            size={'calc(var(--fs-xs)*1.698113)'}
            color={Colors.titlePage}
          >
            {selectedSubscription?.subTitle || translate('noSubscriptionSelected') || ''}
          </TextBase>

        </div>

        <ActiveSubscription
          subscriptionData={selectedSubscription}
          status="paymentPending"
        />

      </Paper>

      <Paper className={css(styles.paymentContainer)}  sx={{marginTop:"calc(var(--sp-md2)*1.132075)"}}>
        <SubscriptionHeader
          leftTitle="selectDefaultCard"
          btnText="edit"
          onClickRight={() => navigateTo(WORK_FLOW_COMMON_SCREENS.CARDS)}
        />
          <PaymentMethodInfo />
          {(isLoading || waitingForDefault) ? (
            <div style={{ height: 'calc(var(--fs-hero)*1.886792)', width:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <CustomSpinner size={resolveCssVarValue('--fs-xl')*1.132075} />
            </div>
          ) : (
              <AllPaymentMethods useGrid />
          )}
      </Paper>

      <Paper className={css(styles.paymentContainer)}  sx={{marginTop:"calc(var(--sp-md2)*1.132075)"}}>
        <ButtonGradient
          disabled={!selectedSubscription || waitingForDefault }
          style={{width: "100%" }}
          title={`${translate('proceedToPay')} $${selectedSubscription?.price || 0}`}
          onClick={handlePay}
          loading={isCreatingSubscription || isUpdatingVendorSubscription}
        />
      </Paper>

      <SuccessModal
        open={successSubscription.showModal}
        data={successSubscription.data}
        onClose={handleCloseSubscription}
        isUpdate={successSubscription.isUpdate}
        role={childAccountData?.role}
      />
      <AddPaymentMethodModal
        open={showAddPaymentModal}
        onClose={() => setShowAddPaymentModal(false)}
        onAddBank={() => {
          setShowAddPaymentModal(false);
          setShowAchModal(true);
        }}
        onAddCard={() => {
          setShowAddPaymentModal(false);
          goAddCard();
        }}
      />

      <ACHBankAccountModal
        open={showAchModal}
        onClose={() => {
          setShowAchModal(false);
        }}
        onLinked={(bank) => {
          setShowAchModal(false);
          setWaitingForDefault(true);
          setWaitingForBankId(bank?.id || bank?.fingerprint || bank?.last4);
        }}
      />

    </>
  )
}
